import { Breadcrumb } from "antd";
import React from "react";
const BreadcrumbComp = ({ items = [] }) => {
  if (!items?.length) {
    return <></>;
  }
  return (
    <div className="w-full overflow-x-auto scrollbar-hide">
      <Breadcrumb
        separator={<img src={"/svg/arrow-right2.svg"} />}
        className="!my-2"
        items={items.map((item, index) => ({
          title: (
            <span
              className={`whitespace-nowrap capitalize text-sm md:text-base py-[6px] px-[12px] hover:text-prim-1000 ${
                items.length === index + 1
                   ? "text-[#0C1B56] font-semibold"
                  : "text-[#333333]"
              }`}
            >
              {item.title}
            </span>
          ),
          href: item.href || "",
          key: index,
        }))}
      />
    </div>
  );
};

export default BreadcrumbComp;
